import {
  getUserFitnessReportDetail,
  getWeeklyCoursesByWeekNo,
  getUserInfo,
} from '@/services/wechat';
import { message } from 'antd';

const ReportModel = {
  namespace: 'report',
  state: {
    page: 0,
    classOrder: '',
    reportList: [],
    planList: [],
    promoteList: [],
    weekPlanList: [],
    mineInfo: {
      userId: '',
      name: '',
    },
    customerInfo: {
      customerId: '',
    },
    targetEnum: [
      // {
      //   id: '1',
      //   name: '健康活力',
      // },
      {
        id: '2',
        name: '减脂塑形',
      },
    ],
    styleEnum: [
      {
        id: '1',
        name: '激进',
      },
      {
        id: '2',
        name: '保守',
      },
      {
        id: '3',
        name: '混合',
      },
    ],
    answerList: [
      '解锁好身材',
      '改善身体状况',
      '精力更加充沛',
      '增强免疫力',
      '其他',
    ],
    reportDetailInfo: {},
    planDetailInfo: {},
    baseData: {},
    classStatusList: [
      '未约课',
      '已约课',
      '预约过期',
      '上课中',
      '完课',
      '失效',
      '',
      '已取消',
    ],
    initBaseData: {},
    updateCount: 0,
  },
  effects: {
    *queryReportDetail({ payload }, { call, put, select }) {
      const { code, msg, data } = yield call(getUserFitnessReportDetail, {
        requestData: {
          ...payload,
        },
      });
      if (code !== '00000') {
        message.error(msg);
      } else {
        yield put({
          type: 'saveReportDetailInfo',
          payload: {
            data,
          },
        });
      }
    },
    *queryPlanDetail({ payload }, { call, put, select }) {
      const { code, msg, data } = yield call(getWeeklyCoursesByWeekNo, {
        requestData: {
          weekNo: payload.weekNo,
          innerUserId: payload.innerUserId,
        },
      });
      if (code !== '00000') {
        message.error(msg);
      } else {
        yield put({
          type: 'savePlanDetailInfo',
          payload: {
            data,
            weekNo: payload.weekNo,
            toPage: payload.toPage,
          },
        });
      }
    },
    *getInnerUserId({ payload }, { call, put }) {
      const { code, data, msg } = yield call(getUserInfo, {
        requestData: {
          userId: payload,
        },
      });
      if (code === '00000') {
        if (!data.userId) {
          return message.error('该用户未注册天天私教，请注册');
        }
        yield put({
          type: 'getBaseInfo',
          payload: data,
        });
      } else {
        message.error(msg);
      }
    },
  },
  reducers: {
    updatePlan(state) {
      return {
        ...state,
        updateCount: ++state.updateCount,
      };
    },
    saveData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    getBaseInfo(state, { payload }) {
      return {
        ...state,
        customerInfo: {
          ...state.customerInfo,
          customerId: payload.userId,
        },
        initBaseData: payload,
        page: 0,
      };
    },
    changePage(state, { payload: { page, data } }) {
      return {
        ...state,
        page,
        ...data,
      };
    },

    saveMyInfo(state, { payload: { data, needStorage } }) {
      if (needStorage) {
        localStorage.setItem('mineInfo', JSON.stringify(data));
      }
      return {
        ...state,
        mineInfo: data,
      };
    },
    saveCustomerInfo(state, { payload: { data } }) {
      return {
        ...state,
        customerInfo: data,
      };
    },
    savePromoteList(state, { payload: { data } }) {
      return {
        ...state,
        promoteList: data,
      };
    },
    saveReportList(state, { payload: { data } }) {
      return {
        ...state,
        reportList: data,
      };
    },
    saveWeekPlanList(state, { payload: { data } }) {
      return {
        ...state,
        planList: data,
      };
    },
    saveReportDetailInfo(state, { payload: { data } }) {
      return {
        ...state,
        page: 1,
        reportDetailInfo: data,
      };
    },
    savePlanDetailInfo(state, { payload: { data, weekNo, toPage } }) {
      if (!toPage) {
        return {
          ...state,
          planDetailInfo: {
            weekNo,
            planDetailList: data,
          },
        };
      }
      return {
        ...state,
        page: 2,
        planDetailInfo: {
          weekNo,
          planDetailList: data,
        },
      };
    },
    saveBaseData(state, { payload: { data } }) {
      return {
        ...state,
        baseData: data,
      };
    },
  },
};
export default ReportModel;
